/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
  ActivateChargingKeyRequest,
  AssignChargingKeyRequest,
  ChargingKeyActionResult,
  ChargingKeyListModel,
  ChargingKeySyncResult,
  ChargingSessionImportResult,
  SetChargingKeyEnabledRequest,
  UnassignChargingKeyRequest,
} from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useChargingKeyImportChargingSessionsHook = () => {
  const chargingKeyImportChargingSessions =
    useCustomInstance<ChargingSessionImportResult>();

  return useCallback(() => {
    return chargingKeyImportChargingSessions({
      url: `/api/ChargingKey/ImportChargingSessions`,
      method: 'POST',
    });
  }, [chargingKeyImportChargingSessions]);
};

export const useChargingKeyImportChargingSessionsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useChargingKeyImportChargingSessionsHook>>
    >,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useChargingKeyImportChargingSessionsHook>>
  >,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const chargingKeyImportChargingSessions =
    useChargingKeyImportChargingSessionsHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useChargingKeyImportChargingSessionsHook>>
    >,
    void
  > = () => {
    return chargingKeyImportChargingSessions();
  };

  return { mutationFn, ...mutationOptions };
};

export type ChargingKeyImportChargingSessionsMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useChargingKeyImportChargingSessionsHook>>
  >
>;

export type ChargingKeyImportChargingSessionsMutationError = unknown;

export const useChargingKeyImportChargingSessions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useChargingKeyImportChargingSessionsHook>>
    >,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useChargingKeyImportChargingSessionsHook>>
  >,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    useChargingKeyImportChargingSessionsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useChargingKeyGetChargingKeysHook = () => {
  const chargingKeyGetChargingKeys = useCustomInstance<ChargingKeyListModel>();

  return useCallback(
    (signal?: AbortSignal) => {
      return chargingKeyGetChargingKeys({
        url: `/api/ChargingKey/GetChargingKeys`,
        method: 'GET',
        signal,
      });
    },
    [chargingKeyGetChargingKeys]
  );
};

export const getChargingKeyGetChargingKeysQueryKey = () => {
  return [`/api/ChargingKey/GetChargingKeys`] as const;
};

export const useChargingKeyGetChargingKeysQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useChargingKeyGetChargingKeysHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useChargingKeyGetChargingKeysHook>>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getChargingKeyGetChargingKeysQueryKey();

  const chargingKeyGetChargingKeys = useChargingKeyGetChargingKeysHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useChargingKeyGetChargingKeysHook>>>
  > = ({ signal }) => chargingKeyGetChargingKeys(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useChargingKeyGetChargingKeysHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ChargingKeyGetChargingKeysQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useChargingKeyGetChargingKeysHook>>>
>;
export type ChargingKeyGetChargingKeysQueryError = unknown;

export const useChargingKeyGetChargingKeys = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useChargingKeyGetChargingKeysHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useChargingKeyGetChargingKeysHook>>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useChargingKeyGetChargingKeysQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useChargingKeySyncChargingKeysHook = () => {
  const chargingKeySyncChargingKeys =
    useCustomInstance<ChargingKeySyncResult>();

  return useCallback(() => {
    return chargingKeySyncChargingKeys({
      url: `/api/ChargingKey/SyncChargingKeys`,
      method: 'POST',
    });
  }, [chargingKeySyncChargingKeys]);
};

export const useChargingKeySyncChargingKeysMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useChargingKeySyncChargingKeysHook>>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useChargingKeySyncChargingKeysHook>>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const chargingKeySyncChargingKeys = useChargingKeySyncChargingKeysHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useChargingKeySyncChargingKeysHook>>>,
    void
  > = () => {
    return chargingKeySyncChargingKeys();
  };

  return { mutationFn, ...mutationOptions };
};

export type ChargingKeySyncChargingKeysMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useChargingKeySyncChargingKeysHook>>>
>;

export type ChargingKeySyncChargingKeysMutationError = unknown;

export const useChargingKeySyncChargingKeys = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useChargingKeySyncChargingKeysHook>>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useChargingKeySyncChargingKeysHook>>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    useChargingKeySyncChargingKeysMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useChargingKeyActivateChargingKeyHook = () => {
  const chargingKeyActivateChargingKey =
    useCustomInstance<ChargingKeyActionResult>();

  return useCallback(
    (activateChargingKeyRequest: ActivateChargingKeyRequest) => {
      return chargingKeyActivateChargingKey({
        url: `/api/ChargingKey/ActivateChargingKey`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: activateChargingKeyRequest,
      });
    },
    [chargingKeyActivateChargingKey]
  );
};

export const useChargingKeyActivateChargingKeyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useChargingKeyActivateChargingKeyHook>>
    >,
    TError,
    { data: ActivateChargingKeyRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useChargingKeyActivateChargingKeyHook>>>,
  TError,
  { data: ActivateChargingKeyRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const chargingKeyActivateChargingKey =
    useChargingKeyActivateChargingKeyHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useChargingKeyActivateChargingKeyHook>>
    >,
    { data: ActivateChargingKeyRequest }
  > = (props) => {
    const { data } = props ?? {};

    return chargingKeyActivateChargingKey(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChargingKeyActivateChargingKeyMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useChargingKeyActivateChargingKeyHook>>>
>;
export type ChargingKeyActivateChargingKeyMutationBody =
  ActivateChargingKeyRequest;
export type ChargingKeyActivateChargingKeyMutationError = unknown;

export const useChargingKeyActivateChargingKey = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useChargingKeyActivateChargingKeyHook>>
    >,
    TError,
    { data: ActivateChargingKeyRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useChargingKeyActivateChargingKeyHook>>>,
  TError,
  { data: ActivateChargingKeyRequest },
  TContext
> => {
  const mutationOptions =
    useChargingKeyActivateChargingKeyMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useChargingKeyAssignChargingKeyHook = () => {
  const chargingKeyAssignChargingKey =
    useCustomInstance<ChargingKeyActionResult>();

  return useCallback(
    (assignChargingKeyRequest: AssignChargingKeyRequest) => {
      return chargingKeyAssignChargingKey({
        url: `/api/ChargingKey/AssignChargingKey`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: assignChargingKeyRequest,
      });
    },
    [chargingKeyAssignChargingKey]
  );
};

export const useChargingKeyAssignChargingKeyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useChargingKeyAssignChargingKeyHook>>>,
    TError,
    { data: AssignChargingKeyRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useChargingKeyAssignChargingKeyHook>>>,
  TError,
  { data: AssignChargingKeyRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const chargingKeyAssignChargingKey = useChargingKeyAssignChargingKeyHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useChargingKeyAssignChargingKeyHook>>>,
    { data: AssignChargingKeyRequest }
  > = (props) => {
    const { data } = props ?? {};

    return chargingKeyAssignChargingKey(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChargingKeyAssignChargingKeyMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useChargingKeyAssignChargingKeyHook>>>
>;
export type ChargingKeyAssignChargingKeyMutationBody = AssignChargingKeyRequest;
export type ChargingKeyAssignChargingKeyMutationError = unknown;

export const useChargingKeyAssignChargingKey = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useChargingKeyAssignChargingKeyHook>>>,
    TError,
    { data: AssignChargingKeyRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useChargingKeyAssignChargingKeyHook>>>,
  TError,
  { data: AssignChargingKeyRequest },
  TContext
> => {
  const mutationOptions =
    useChargingKeyAssignChargingKeyMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useChargingKeyUnassignChargingKeyHook = () => {
  const chargingKeyUnassignChargingKey =
    useCustomInstance<ChargingKeyActionResult>();

  return useCallback(
    (unassignChargingKeyRequest: UnassignChargingKeyRequest) => {
      return chargingKeyUnassignChargingKey({
        url: `/api/ChargingKey/UnassignChargingKey`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: unassignChargingKeyRequest,
      });
    },
    [chargingKeyUnassignChargingKey]
  );
};

export const useChargingKeyUnassignChargingKeyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useChargingKeyUnassignChargingKeyHook>>
    >,
    TError,
    { data: UnassignChargingKeyRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useChargingKeyUnassignChargingKeyHook>>>,
  TError,
  { data: UnassignChargingKeyRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const chargingKeyUnassignChargingKey =
    useChargingKeyUnassignChargingKeyHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useChargingKeyUnassignChargingKeyHook>>
    >,
    { data: UnassignChargingKeyRequest }
  > = (props) => {
    const { data } = props ?? {};

    return chargingKeyUnassignChargingKey(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChargingKeyUnassignChargingKeyMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useChargingKeyUnassignChargingKeyHook>>>
>;
export type ChargingKeyUnassignChargingKeyMutationBody =
  UnassignChargingKeyRequest;
export type ChargingKeyUnassignChargingKeyMutationError = unknown;

export const useChargingKeyUnassignChargingKey = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useChargingKeyUnassignChargingKeyHook>>
    >,
    TError,
    { data: UnassignChargingKeyRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useChargingKeyUnassignChargingKeyHook>>>,
  TError,
  { data: UnassignChargingKeyRequest },
  TContext
> => {
  const mutationOptions =
    useChargingKeyUnassignChargingKeyMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useChargingKeySetChargingKeyEnabledHook = () => {
  const chargingKeySetChargingKeyEnabled =
    useCustomInstance<ChargingKeyActionResult>();

  return useCallback(
    (setChargingKeyEnabledRequest: SetChargingKeyEnabledRequest) => {
      return chargingKeySetChargingKeyEnabled({
        url: `/api/ChargingKey/SetChargingKeyEnabled`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: setChargingKeyEnabledRequest,
      });
    },
    [chargingKeySetChargingKeyEnabled]
  );
};

export const useChargingKeySetChargingKeyEnabledMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useChargingKeySetChargingKeyEnabledHook>>
    >,
    TError,
    { data: SetChargingKeyEnabledRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useChargingKeySetChargingKeyEnabledHook>>
  >,
  TError,
  { data: SetChargingKeyEnabledRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const chargingKeySetChargingKeyEnabled =
    useChargingKeySetChargingKeyEnabledHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useChargingKeySetChargingKeyEnabledHook>>
    >,
    { data: SetChargingKeyEnabledRequest }
  > = (props) => {
    const { data } = props ?? {};

    return chargingKeySetChargingKeyEnabled(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChargingKeySetChargingKeyEnabledMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useChargingKeySetChargingKeyEnabledHook>>
  >
>;
export type ChargingKeySetChargingKeyEnabledMutationBody =
  SetChargingKeyEnabledRequest;
export type ChargingKeySetChargingKeyEnabledMutationError = unknown;

export const useChargingKeySetChargingKeyEnabled = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useChargingKeySetChargingKeyEnabledHook>>
    >,
    TError,
    { data: SetChargingKeyEnabledRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useChargingKeySetChargingKeyEnabledHook>>
  >,
  TError,
  { data: SetChargingKeyEnabledRequest },
  TContext
> => {
  const mutationOptions =
    useChargingKeySetChargingKeyEnabledMutationOptions(options);

  return useMutation(mutationOptions);
};
